





















import { defineComponent } from '@vue/composition-api';
import svgCom from '@components/Svg/index';

export default defineComponent({
  name: 'GuidePage',
  components: {
    svgCom,
  },
  setup(props, {root}) {
    const bankInfo = [
      {bankName: '招商银行', path: 'guide1'},
      {bankName: '建设银行', path: 'guide2'},
      {bankName: '平安银行', path: 'guide3'},
      {bankName: '中国银行', path: 'guide4'},
    ];
    const routeQuery = root.$route.fullPath;
    
    return {
      bankInfo,
      routeQuery
    };
  }
});
